export const features = {
  STARTUP_FOLLOW: true,
}

export default {
  features,
}

window.features = features
// this allows to change features "on thy fly", ie:
// Vue.set(features, 'STARTUP_FOLLOW', true)
